import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../assets/css/HomeBlogSection.css";
import { useNavigate } from "react-router-dom";
import HomeBlogOne from "../../assets/image/HomeBlog/HomeBlog-1.jpg";
import drone1 from "../../assets/image/Home/drone1.jpg";
import automation from "../../assets/image/Home/automation.jpg";
import prototyping from "../../assets/image/Home/prototyping.jpg";
import HomeBlogTwo from "../../assets/image/HomeBlog/HomeBlog-2.png";
import HomeBlogThree from "../../assets/image/HomeBlog/HomeBlog-3.png";
import HomeBlogFour from "../../assets/image/HomeBlog/HomeBlog-4.png";

const blogData = [
  {
    title: "How Drone Technology is Transforming Industries",
    description:
      "Explore how drones are revolutionizing sectors like construction, agriculture, and infrastructure with precision data and automation.",
    image: drone1,
  },
  {
    title: "AI & Automation: The Future of Smart Businesses",
    description:
      "Learn how AI-driven systems and automation are helping businesses improve efficiency, reduce costs, and make smarter decisions.",
    image: automation,
  },
  {
    title: "Drone Survey & Mapping Explained",
    description:
      "Understand how aerial mapping and GIS data collection are improving accuracy and speed in modern surveying projects.",
    image: drone1,
  },
  {
    title: "IoT in Real-World Applications",
    description:
      "Discover how connected devices and smart systems are transforming industries with real-time monitoring and intelligent control.",
    image: prototyping,
  },
];

const HomeBlogSection = () => {
  const navigate = useNavigate();

  const handleClickBlog = () => {
    navigate("/blog");
  };

  const clicktosubblog = () => {
    navigate("/blogsub_1");
  };

  const sliderSettingsHomeBlog = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // 2 cards visible on tablets (992px)
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1, // 1 card visible on mobile (768px)
        },
      },
    ],
  };

  return (
    <div className="container" style={{ marginTop: "40px" }}>
      {/* Top Row - Content */}
      <div className="row mb-4">
        <div className="col-lg-12">
          <div className="text-center mb-3">
            <button className="btn border border-danger fw-semibold bg-transparent font-red-home-blog px-3 py-2 rounded-pill fs-6 fs-md-5">
              OUR BLOG
            </button>
          </div>
          <h3 className="display-5 fw-bold font-dark mb-3">
            Latest Insights from <span className="font-red-home-blog">Shiv NextGen</span>
          </h3>

          {/* Paragraph and Button Side by Side */}
          <div className="row align-items-center">
            <div className="col-md-6 col-12">
              <p className="font-para-home-blog mb-md-0 mb-3">
                Stay updated with the latest insights, innovations, and trends in
                Drone Technology, AI, IoT, Robotics, and modern digital solutions.
              </p>
            </div>
            <div className="col-md-6 col-12 text-md-end">
              <button
                className="btn btn-red text-white fw-semibold px-4 py-2"
                onClick={handleClickBlog}
              >
                Explore Blog →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Row - Slider */}
      <div className="row">
        <div className="col-12">
          <Slider {...sliderSettingsHomeBlog}>
            {blogData.map((blog, index) => (
              <div key={index} className="home-blog-card-wrapper px-2">
                <div
                  className="home-blog-card rounded p-3 h-100 bg-white d-flex flex-column"
                  style={{ height: "350px" }} // Fixed height for consistent card size
                >
                  <div className="overflow-hidden" style={{ height: "200px" }}>
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="img-fluid rounded mb-3"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "200px",
                      }}
                    />
                  </div>
                  <h5 className="home-blog-card-title mt-2 fw-bold">
                    {blog.title}
                  </h5>
                  <p className="home-blog-card-text">{blog.description}</p>
                  <div className="mt-auto">
                    <span
                      className="border border-danger rounded-2 px-2 py-1 bg-red text-white"
                      style={{ cursor: "pointer" }}
                      onClick={clicktosubblog}
                    >
                      Explore Now <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default HomeBlogSection;
